import "./price-button.css"

import { ButtonHTMLAttributes, PropsWithChildren } from "react"

import { isBuy } from "@/App/Credit/common"
import { AdaptiveLoader } from "@/components/AdaptiveLoader"
import { Direction } from "@/generated/TradingGateway"
import { join } from "@/utils/join"

import { PriceButtonVariant } from "./types"

const getDirectionColorClass = (direction: Direction) =>
  isBuy(direction) ? "bg-buy-primary" : "bg-sell-primary"

const getDirectionColorHoverClass = (direction: Direction) =>
  isBuy(direction) ? "hover:bg-buy-primary" : "hover:bg-sell-primary"

interface Props {
  variant: PriceButtonVariant
  direction: Direction
}

export const PriceButtonButton = ({
  variant,
  direction,
  ...props
}: PropsWithChildren<Props & ButtonHTMLAttributes<HTMLButtonElement>>) => {
  const className =
    "price-button rounded-xxs self-center flex h-11/12 w-full flex-col items-center justify-center relative border-0 outline-0 transition-colors duration-200 hover:text-primary"

  const backgroundEffectClass = isBuy(direction)
    ? "buy-bg-effect"
    : "sell-bg-effect"

  const classes: Record<typeof variant, string> = {
    primary: join(
      getDirectionColorHoverClass(direction),
      "cursor-pointer hover:text-white",
    ),
    priceAnnounced: join(
      getDirectionColorHoverClass(direction),
      backgroundEffectClass,
      "bg-primary  cursor-pointer",
      isBuy(direction)
        ? "buy-bg-effect text-buy-primary"
        : "sell-bg-effect text-sell-primary",
    ),
    disabled: "text-disabled cursor-auto pointer-events-none",
    pending: "",
    active: getDirectionColorClass(direction),
  }

  return variant === "pending" ? (
    <div className={className}>
      <AdaptiveLoader size={16} />
      <p className="pt-xxs text-sm-regular text-secondary">Awaiting Price</p>
    </div>
  ) : (
    <button
      className={join(
        "appearance-none focus:outline-none",
        className,
        classes[variant],
      )}
      {...props}
    />
  )
}
